module.exports = __webpack_public_path__ + "static/media/Step6.f0180eae.png";